import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

const scanLabelSerializeMap: SerializeMap<ScanLabel> = {
  id: "id",
  scanId: "scan_id",
  archetype: "archetype",
  name: "name",
  livestockSaleId: "livestock_sale_id",
  permissions: "permissions",
};

export const serializeScanLabel = buildSerializer(
  scanLabelSerializeMap,
  "scanLabel",
);

export const deserializeScanLabel = buildDeserializer<ScanLabel>(
  scanLabelSerializeMap,
  "scanLabel",
);
